export default __webpack_public_path__ + "static/media/3.cd5393ff.jpg";